import * as AmazonCognitoIdentity from 'amazon-cognito-identity-js';

import {awsConfig} from '../../shared/config';


export const getCurrentUserFromUserPool = () => {
    var poolData = { 
        UserPoolId : awsConfig.cognito.userPoolId,
        ClientId : awsConfig.cognito.userPoolClientId
    };
    var userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
    var cognitoUser = userPool.getCurrentUser();

    return cognitoUser;
}


export const isCurrentUserSessionActive = () => {
    var isActive = false;

    const cognitoUser = getCurrentUserFromUserPool();
    if(cognitoUser !=null) {
        try{
            cognitoUser.getSession(function(err, session) {
                    if (err) {
                        console.log(">> Error getting the session: " + err);
                    }
                    else{
                        isActive = session.isValid();
                    }
                }
            )
        }
        catch(error) {
            console.log("Session Error: " + error);
        }
    }
    else {
        console.log(">> No CognitoUser");
    }    

    return isActive;
}